import { Overlay } from './Color';
import { Size as PaddingSize } from './Spacing';
import { Size as MarginSize } from './Spacing';

export const Size = {
  Small: 360,
  Medium: 500,
  Large: 768,
  XLarge: 900,
};

export const Padding = {
  XSmall: PaddingSize.XSmall,
  Small: PaddingSize.Small,
  Medium: PaddingSize.MediumSmall,
  Large: PaddingSize.MediumLarge,
};

export const Margin = {
  XSmall: MarginSize.XXSmall,
  Small: MarginSize.XSmall,
  Medium: MarginSize.Medium,
  Large: MarginSize.MediumLarge,
  XLarge: MarginSize.Large,
  XXLarge: MarginSize.XLarge,
};

export const OverlayColor = Overlay.Default;
